module.exports = __webpack_public_path__ + "img/ricelog_pinicon_031.97f76073.png";